


















































































































import {Component, Mixins} from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import Breadcrumb from '@/models/Breadcrumb';
import {ResponsiveMixin} from '@/mixins/ResponsiveMixin';
import vue2Dropzone from 'vue2-dropzone';
import SecurityModule from '@/store/modules/SecurityModule';
import {importSession} from '@/repositories/api/ImportedSessionApi';
import Alert from '@/models/Alert';
import {AlertTypes} from '@/models/AlertTypes';
import Action from '@/models/Action';
import Overlay from '@/models/Overlay';
import axios from '@/libraries/axios/main'

const uuid = require('uuid/v1');

@Component({
    components: {
        DropZone: vue2Dropzone,
        BaseLayout,
    }
})
export default class SessionImportView extends Mixins(ResponsiveMixin) {
    protected dialog = false;
    protected overlay = new Overlay();
    protected haveFiles = false;
    protected isFilesSend = false;
    protected isFilesImported = false;
    protected isSingle = false;
    protected isSending = false;
    protected alert = new Alert();
    protected actions: Action[] = [];
    protected breadcrumbs: Breadcrumb[] = [
        new Breadcrumb('Accueil', '/'),
        new Breadcrumb('Sessions', '/sessions'),
        new Breadcrumb('Nouvel import', '/sessions/importées', true),
    ];
    protected sessionName = uuid();
    protected showImport = false;
    protected notifications: {
        title: string;
        type: string;
        message: string;
        content: string;
        date: Date;
        label: string;
        status: string;
    }[] = [];
    protected showTimeLine = false;
    protected importing = false;
    protected dropZone: any = null;

    get computedDropZoneOptions() {
        return {
            autoProcessQueue: false,
            paramName: 'files',
            url: (window.location.hostname.includes('.vpc') ? process.env.VUE_APP_API_BASE_URL.replace('.fr', '.vpc') : process.env.VUE_APP_API_BASE_URL) + '/session/upload',
            thumbnailWidth: 150,
            dictDefaultMessage: 'Déposer les fichiers ici',
            headers: {
                Authorization: 'bearer ' + SecurityModule.token,
            },

            maxFilesize: 8, // MB
            thumbnailHeight: 150,
        };
    }

    onDropZoneFileAdded(file: File) {
        this.haveFiles = true;
        this.isSingle = file.type == 'application/zip';
        // this.sessionName = (file.type == 'application/zip') ? file.name.split('.').slice(0, -1).join('.') + moment().format('_YYYY-DD-MM_HH:MM:SS') : this.sessionName;

        (this.dropZone.getAcceptedFiles() as File[]).forEach(
            addedFile => {
                if (file.type == 'application/zip' && addedFile !== file) {
                    this.dropZone.removeFile(addedFile);
                } else if (addedFile.type == 'application/zip') {
                    this.sessionName = uuid();
                    this.dropZone.removeFile(addedFile);
                }

                if (addedFile == file) {
                    this.dropZone.removeFile(addedFile);
                }
            });
    }

    onDropZoneSuccess(file: File, response: any) {
        this.showImport = true;

        this.dropZone.removeAllFiles();
        this.dropZone.disable();

        this.alert = new Alert('Fichier(s) envoyé avec succès sur le serveur', AlertTypes.Success, true);
        this.isFilesSend = true;
    }

    onDropZoneSending(file: File, xhr: XMLHttpRequest, formData: FormData) {
        this.isSending = true;
        this.overlay.text = 'Envoi de fichiers..';
        this.overlay.show = true;
        formData.append('uuid', this.sessionName);
    }

    onDropZoneComplete(response: any) {
        this.overlay.show = false;
        this.isSending = false;
    }

    onDropZoneCanceled(file: File) {
        this.alert = new Alert('Envoi des fichiers annulé', AlertTypes.Warning, true);
    }

    onDropZoneError(file: File, message: string, xhr: XMLHttpRequest) {
        this.alert = new Alert(message, AlertTypes.Error, true);
    }

    clearDropZone() {
        if (
            this.dropZone
        ) {
            this.dropZone.getAcceptedFiles()
                .forEach((file: File) => this.dropZone.removeFile(file));
        }
    }

    reset() {
        this.dialog = false;
        this.overlay = new Overlay();
        this.alert = new Alert();
        this.isSingle = false;
        this.isFilesImported = false;
        this.haveFiles = false;
        this.sessionName = uuid();
        this.dropZone.removeAllFiles();
        this.dropZone.enable();

        this.isFilesSend = false;
        this.isSending = false;
        this.showImport = false;
        this.notifications = [];
        this.showTimeLine = false;
        this.importing = false;
    }

    closeImport(eventSource: EventSource) {
        this.importing = false;
        this.clearDropZone();
        eventSource.close();
        this.importing = false;
        this.overlay.show = false;
    }

    async sendFiles() {
        this.dropZone.processQueue();
    }

    async importFiles() {
        let tries = 1000;

        this.notifications = [];
        this.importing = true;
        this.showTimeLine = true;
        this.showImport = false;
        this.overlay.text = 'Import des fichiers en cours';
        this.overlay.show = true;

        const polling = setInterval(async () => {
            const response = await axios.get("/session/import/notification/" + this.sessionName);
            const notificationData = response.data;

            if (notificationData) {
                let notification: {
                    title: string;
                    type: string;
                    message: string;
                    content: string;
                    date: Date;
                    label: string;
                    status: string;
                } = {
                    title: notificationData.title,
                    type: notificationData.type,
                    message: notificationData.message,
                    content: notificationData.content,
                    date: new Date(),
                    label: notificationData.label,
                    status: notificationData.status
                };

                this.alert = new Alert(notification.title, notification.type, true);
                this.notifications.unshift(notification);

                if(notification.type == "info"){
                    tries = 1000;
                }

                if (notification.type == "success" || notification.type == "error") {
                    clearInterval(polling);

                    this.isFilesImported = notification.type == 'success';
                    this.overlay.show = false;
                }
            } else {
                if (--tries <= 0) {
                    let notification: {
                        title: string;
                        type: string;
                        message: string;
                        content: string;
                        date: Date;
                        label: string;
                        status: string;
                    } = {
                        title: 'Erreur',
                        type: 'error',
                        message: 'Une erreur est survenue lors de l\'import',
                        content: '',
                        date: new Date(),
                        label: 'Erreur',
                        status: 'danger'
                    };

                    clearInterval(polling);

                    this.importing = false;
                    this.notifications.unshift(notification);
                    this.alert = new Alert(notification.message, notification.type, true);
                    this.overlay.show = false;
                }
            }
        }, 2000);

        await importSession(this.sessionName);
    }

    clear() {
        this.reset();
    }

    created() {
        this.actions = [
            new Action(() => {
                this.$router.push({name: 'session_imported'});
            }, 'Retour', '', 'mdi-home')
        ];
    }

    mounted() {
        this.dropZone = this.$refs.vueDropZone;
        this.reset();
    }
}
